/**
 * The available SOML RBAC role action types.
 */
export enum RbacRoleActionType {
  READ = "READ",
  WRITE = "WRITE",
  DELETE = "DELETE",
  BIND = "BIND",
  ALL = "ALL"
}
